/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaRuolo } from '@models';

@Pipe({
    name: 'anagraficaRuolo',
})
export class AnagraficaRuoloPipe implements PipeTransform {

    transform(value: number, items: AnagraficaRuolo[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
